import React from 'react';
import { Heart, Sprout, BookOpen, Droplets, Users, Sun } from 'lucide-react';
import { PageHero } from './AboutPage';

const initiatives = [
  { icon: Sprout, title: 'Farmer Empowerment', desc: 'Partnered with 12,000+ farmers across 8 states, providing fair-trade contracts for agricultural residue and training in sustainable practices.' },
  { icon: BookOpen, title: 'Green Schools', desc: 'Installed solar systems in 250+ rural schools and launched clean-energy curriculum benefiting 80,000+ students annually.' },
  { icon: Droplets, title: 'Water Conservation', desc: 'Built 140 rainwater harvesting structures and restored 60 village ponds across our plant communities.' },
  { icon: Users, title: 'Skill Development', desc: 'Trained 4,000+ youth in renewable energy operations — 90% placed in green-collar jobs across India.' },
  { icon: Sun, title: 'Clean Cooking', desc: 'Distributed 25,000 BioCNG cooking connections to rural households, replacing wood and kerosene.' },
  { icon: Heart, title: 'Healthcare Outreach', desc: 'Solar-powered mobile health clinics serving 100+ villages with free check-ups and medicines.' },
];

const CSRPage = () => (
  <div>
    <PageHero title="Corporate Social Responsibility" subtitle="Energy with empathy — building stronger, greener communities." />

    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className="rounded-3xl overflow-hidden shadow-2xl shadow-emerald-100">
          <img src="https://images.pexels.com/photos/9799743/pexels-photo-9799743.jpeg" alt="Community impact" className="w-full h-[460px] object-cover" />
        </div>
        <div>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 text-xs font-semibold uppercase tracking-widest">Our Pledge</div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold text-[#0b1a1a] leading-tight">Beyond Energy. <span className="text-emerald-600">Building Bharat.</span></h2>
          <p className="mt-5 text-slate-600 leading-relaxed text-lg">At Indian Energreen, sustainability extends beyond fuel — every plant is also a community hub. We invest 2% of our profits into rural development, education, healthcare and environmental restoration around our facilities.</p>
          <div className="mt-8 grid grid-cols-3 gap-4">
            <div><div className="text-3xl font-extrabold text-emerald-600">12K+</div><div className="text-xs text-slate-500 font-bold uppercase mt-1">Farmers</div></div>
            <div><div className="text-3xl font-extrabold text-emerald-600">250+</div><div className="text-xs text-slate-500 font-bold uppercase mt-1">Solar Schools</div></div>
            <div><div className="text-3xl font-extrabold text-emerald-600">100K+</div><div className="text-xs text-slate-500 font-bold uppercase mt-1">Lives Impacted</div></div>
          </div>
        </div>
      </div>
    </section>

    <section className="py-20 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0b1a1a]">Our <span className="text-emerald-600">Initiatives</span></h2>
        </div>
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {initiatives.map((it) => (
            <div key={it.title} className="bg-white rounded-3xl p-7 border border-slate-100 hover:border-emerald-200 hover:-translate-y-1 transition-all shadow-sm hover:shadow-xl hover:shadow-emerald-100">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-400 to-emerald-600 grid place-items-center shadow-md shadow-emerald-200">
                <it.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="mt-5 text-xl font-extrabold text-[#0b1a1a]">{it.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-sm">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default CSRPage;
